// Token storage, deliberately free of Vue/Pinia so the HTTP layer can read and
// rotate tokens without importing the session store (which imports HTTP).

const ACCESS_KEY = "safy.admin.accessToken"
const REFRESH_KEY = "safy.admin.refreshToken"

export interface TokenPair {
  accessToken: string
  refreshToken: string
}

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_KEY)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY)
}

export function setTokens({ accessToken, refreshToken }: TokenPair): void {
  localStorage.setItem(ACCESS_KEY, accessToken)
  localStorage.setItem(REFRESH_KEY, refreshToken)
}

export function clearTokens(): void {
  localStorage.removeItem(ACCESS_KEY)
  localStorage.removeItem(REFRESH_KEY)
}
